module.exports = __webpack_public_path__ + "static/media/cover.8a9e5131.svg";